import { useId } from 'react'
import PropTypes from 'prop-types'

const SIZE = 18
const BORDER_WIDTH = 2
const BORDER_COLOR = '#FFFFFF'
const OUTER = SIZE + BORDER_WIDTH * 2

const CIRCLE_FILL = '#093844'

const circlePathD =
  'M9 0C4.03725 0 0 4.03725 0 9C0 13.9628 4.03725 18 9 18C13.9628 18 18 13.9628 18 9C18 4.03725 13.9628 0 9 0Z'

const checkPathD =
  'M8.93175 11.5642C8.6415 11.8545 8.25975 11.9992 7.8765 11.9992C7.49325 11.9992 7.10775 11.853 6.8145 11.5605L4.728 9.5385L5.77275 8.46075L7.8675 10.491L12.2242 6.21525L13.2772 7.284L8.93175 11.5642Z'

function isCheckCutout(color) {
  return !color || color === 'transparent'
}

const CheckCircle = ({ color = 'transparent', withBorder = false, ...rest }) => {
  const maskId = `ccf-m-${useId().replace(/:/g, '')}`
  const cutout = isCheckCutout(color)

  const svg = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={SIZE}
      height={SIZE}
      viewBox="0 0 18 18"
      fill="none"
      style={{ display: 'block' }}
    >
      {cutout && (
        <defs>
          <mask
            id={maskId}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="18"
            height="18"
          >
            <path d={circlePathD} fill="white" />
            <path d={checkPathD} fill="black" />
          </mask>
        </defs>
      )}
      {cutout ? (
        <path
          d={circlePathD}
          fill={CIRCLE_FILL}
          mask={`url(#${maskId})`}
        />
      ) : (
        <>
          <path d={circlePathD} fill={CIRCLE_FILL} />
          <path d={checkPathD} fill={color} />
        </>
      )}
    </svg>
  )

  if (!withBorder) {
    return <span {...rest}>{svg}</span>
  }

  return (
    <span
      style={{
        display: 'inline-flex',
        width: OUTER,
        height: OUTER,
        boxSizing: 'border-box',
        alignItems: 'center',
        justifyContent: 'center',
        border: `${BORDER_WIDTH}px solid ${BORDER_COLOR}`,
        borderRadius: '50%',
        lineHeight: 0,
        verticalAlign: 'middle',
      }}
      {...rest}
    >
      {svg}
    </span>
  )
}

CheckCircle.propTypes = {
  color: PropTypes.string,
  withBorder: PropTypes.bool,
}

export default CheckCircle
